var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Globale Komponentenhilfe")]),_c('p',[_vm._v("Ein Eintrag je technischem Komponententyp. Änderungen gelten für alle Customizing-Formulare.")]),(_vm.error)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('div',{ref:"renderer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }